(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  (function() {
    var bar = document.querySelector('[data-ar-bar]');
    var article = document.querySelector('.ar__content');
    if (bar && article) {
      var tick = function() {
        var r = article.getBoundingClientRect();
        var total = r.height - window.innerHeight;
        var done = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
        bar.style.width = (done * 100) + '%';
      };
      window.addEventListener('scroll', tick, { passive: true });
      window.addEventListener('resize', tick);
      tick();
    }

    var copy = document.querySelector('[data-ar-copy]');
    var msg = document.querySelector('[data-ar-copied]');
    if (copy) {
      copy.addEventListener('click', function() {
        var url = copy.getAttribute('data-url');
        var done = function() {
          if (!msg) return;
          msg.hidden = false;
          setTimeout(function() { msg.hidden = true; }, 2200);
        };
        if (navigator.clipboard) navigator.clipboard.writeText(url).then(done).catch(function() {});
        else done();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["back2school"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.b2s').forEach(function(sec) {
      var tabs = sec.querySelectorAll('[data-b2s-tab]');
      var panels = sec.querySelectorAll('[data-b2s-panel]');
      tabs.forEach(function(t) {
        t.addEventListener('click', function() {
          var g = t.getAttribute('data-b2s-tab');
          tabs.forEach(function(x) { var on = x === t; x.classList.toggle('b2s__tab--active', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
          panels.forEach(function(p) {
            var on = p.getAttribute('data-b2s-panel') === g;
            p.classList.toggle('b2s__panel--active', on);
            if (on) p.querySelectorAll('[data-reveal]').forEach(function(el) { el.classList.add('is-in'); });
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-qty-wrap]').forEach(function(wrap) {
      var input = wrap.querySelector('[data-qty-input]');
      var minus = wrap.querySelector('[data-qty-minus]');
      var plus = wrap.querySelector('[data-qty-plus]');
      if (!input) return;
      var busy = false;

      function update(newVal) {
        if (busy) return;
        if (newVal < 1) newVal = 1;
        busy = true;
        input.value = newVal;
        wrap.style.opacity = '0.5';
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: parseInt(input.getAttribute('data-line'), 10), quantity: newVal })
        }).then(function() {
          window.location.reload();
        }).catch(function() {
          busy = false;
          wrap.style.opacity = '';
        });
      }

      minus.addEventListener('click', function() { update(parseInt(input.value, 10) - 1); });
      plus.addEventListener('click', function() { update(parseInt(input.value, 10) + 1); });
      input.addEventListener('change', function() { update(parseInt(input.value, 10) || 1); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function() {
    /* Sort */
    var sortSelect = document.querySelector('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        window.location.href = url.toString();
      });
    }

    /* Mobile filter drawer */
    var toggle = document.querySelector('[data-filter-toggle]');
    var drawer = document.querySelector('[data-filter-drawer]');
    var overlay = document.querySelector('[data-filter-overlay]');
    var closeBtn = document.querySelector('[data-filter-close]');

    function openDrawer() {
      if (drawer) drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      if (drawer) drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    if (toggle) toggle.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
  })();
  // Opis kategorije: dugme se pokazuje samo ako tekst zaista prelazi skraćeni prikaz
  (function() {
    var wrap = document.querySelector('[data-coll-desc]');
    if (!wrap) return;
    var text = wrap.querySelector('[data-coll-desc-text]');
    var btn = wrap.querySelector('[data-coll-desc-toggle]');
    var label = wrap.querySelector('[data-coll-desc-label]');
    if (!text || !btn) return;

    var MORE = label ? label.textContent : '';
    var LESS = btn.getAttribute('data-less') || 'Prikaži manje';
    var more = text.querySelector('.coll__desc-more');

    function sync() {
      if (wrap.classList.contains('is-open')) return;
      // Strukturisan opis: sklapa se samo blok .coll__desc-more, ostalo je uvek vidljivo.
      // Običan tekst: skraćuje se na 4 reda, pa dugme ima smisla tek ako tekst prelazi taj okvir.
      btn.hidden = more ? false : text.scrollHeight <= text.clientHeight + 4;
    }

    if (more) {
      text.style.maxHeight = 'none';
      text.classList.add('coll__desc-text--structured');
    }

    btn.addEventListener('click', function() {
      var open = wrap.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (label) label.textContent = open ? LESS : MORE;
    });

    sync();
    window.addEventListener('resize', sync);
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["community"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.cm').forEach(function(sec) {
      var track = sec.querySelector('[data-cm-track]');
      if (!track) return;
      function step() { var c = track.querySelector('.cm__card'); return c ? c.getBoundingClientRect().width + 20 : 320; }
      var prev = sec.querySelector('[data-cm-prev]'), next = sec.querySelector('[data-cm-next]');
      prev && prev.addEventListener('click', function() { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next && next.addEventListener('click', function() { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      // Duga recenzija: skrati na 8 redova i pokazi dugme samo ako tekst zaista prelazi
      sec.querySelectorAll('[data-cm-quote]').forEach(function(q) {
        var btn = q.parentElement.querySelector('[data-cm-more]');
        if (!btn) return;
        q.classList.add('cm__quote--clamp');
        if (q.scrollHeight > q.clientHeight + 4) {
          btn.hidden = false;
          btn.addEventListener('click', function() {
            var open = q.classList.toggle('cm__quote--clamp');
            btn.textContent = open ? 'Prikaži celu recenziju' : 'Prikaži manje';
          });
        } else {
          q.classList.remove('cm__quote--clamp');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-fp-item]').forEach(function(item) {
      var body = item.querySelector('[data-fp-body]');
      var summary = item.querySelector('summary');
      if (!body || !summary || reduce) return;
      body.style.transition = 'height .35s cubic-bezier(.2,.7,.2,1)';
      summary.addEventListener('click', function(e) {
        e.preventDefault();
        if (item.open) {
          body.style.height = body.scrollHeight + 'px';
          requestAnimationFrame(function() { body.style.height = '0px'; });
          body.addEventListener('transitionend', function done() { item.open = false; body.style.height = ''; body.removeEventListener('transitionend', done); });
        } else {
          item.open = true;
          var h = body.scrollHeight;
          body.style.height = '0px';
          requestAnimationFrame(function() { body.style.height = h + 'px'; });
          body.addEventListener('transitionend', function done() { body.style.height = ''; body.removeEventListener('transitionend', done); });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // Meko otvaranje i zatvaranje odgovora (details nema animaciju sam po sebi)
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-fq-item]').forEach(function(item) {
      var body = item.querySelector('[data-fq-body]');
      var summary = item.querySelector('summary');
      if (!body || !summary || reduce) return;
      summary.addEventListener('click', function(e) {
        e.preventDefault();
        if (item.open) {
          body.style.height = body.scrollHeight + 'px';
          requestAnimationFrame(function() { body.style.height = '0px'; });
          body.addEventListener('transitionend', function done() {
            item.open = false; body.style.height = ''; body.removeEventListener('transitionend', done);
          });
        } else {
          item.open = true;
          var h = body.scrollHeight;
          body.style.height = '0px';
          requestAnimationFrame(function() { body.style.height = h + 'px'; });
          body.addEventListener('transitionend', function done() { body.style.height = ''; body.removeEventListener('transitionend', done); });
        }
      });
      body.style.transition = 'height .35s cubic-bezier(.2,.7,.2,1)';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.featured-products__tabs').forEach(function(tablist) {
      var tabs = tablist.querySelectorAll('.featured-products__tab');
      var section = tablist.closest('.featured-products');

      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          var targetId = tab.getAttribute('data-tab-target');

          tabs.forEach(function(t) {
            t.classList.remove('featured-products__tab--active');
            t.setAttribute('aria-selected', 'false');
          });

          section.querySelectorAll('.featured-products__panel').forEach(function(panel) {
            panel.classList.remove('featured-products__panel--active');
            panel.hidden = true;
          });

          tab.classList.add('featured-products__tab--active');
          tab.setAttribute('aria-selected', 'true');

          var panel = document.getElementById('fp-panel-' + targetId);
          if (panel) {
            panel.classList.add('featured-products__panel--active');
            panel.hidden = false;
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flagship-product-form"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('.flagship-form');
    if (!section) return;

    /* Quantity +/- */
    var qtyInput = section.querySelector('[data-qty-input]');
    var qtyMinus = section.querySelector('[data-qty-minus]');
    var qtyPlus = section.querySelector('[data-qty-plus]');
    if (qtyInput && qtyMinus && qtyPlus) {
      qtyMinus.addEventListener('click', function() {
        var v = parseInt(qtyInput.value, 10);
        if (v > 1) qtyInput.value = v - 1;
      });
      qtyPlus.addEventListener('click', function() {
        qtyInput.value = parseInt(qtyInput.value, 10) + 1;
      });
    }

    /* Variant option selection */
    var variantSelect = section.querySelector('[data-variant-select]');
    var optionInputs = section.querySelectorAll('[data-option-input]');
    var addBtn = section.querySelector('[data-add-btn]');

    if (!variantSelect || optionInputs.length === 0) return;

    optionInputs.forEach(function(input) {
      input.addEventListener('change', function() {
        var parent = this.closest('.flagship-form__option-values');
        parent.querySelectorAll('.flagship-form__option-btn').forEach(function(btn) {
          btn.classList.remove('flagship-form__option-btn--active');
        });
        this.closest('.flagship-form__option-btn').classList.add('flagship-form__option-btn--active');

        var selected = [];
        section.querySelectorAll('[data-option-input]:checked').forEach(function(checked) {
          selected[parseInt(checked.getAttribute('data-option-index'), 10)] = checked.value;
        });

        var options = variantSelect.querySelectorAll('option');
        for (var i = 0; i < options.length; i++) {
          var opt = options[i];
          var match = true;
          for (var j = 0; j < selected.length; j++) {
            if (opt.getAttribute('data-option' + (j + 1)) !== selected[j]) {
              match = false;
              break;
            }
          }
          if (match) {
            variantSelect.value = opt.value;
            var available = opt.getAttribute('data-available') === 'true';
            if (addBtn) {
              addBtn.disabled = !available;
            }
            /* Update the hero image when color/variant changes */
            var vImg = opt.getAttribute('data-variant-image');
            if (vImg && window.bbSetMainImage) window.bbSetMainImage(vImg, vImg);
            var url = new URL(window.location.href);
            url.searchParams.set('variant', opt.value);
            history.replaceState(null, '', url.toString());
            break;
          }
        }
      });
    });

    /* ── Oprema za doplatu: dodaje se u korpu zajedno sa modelom ── */
    var addonsBox = section.querySelector('[data-ff-addons]');
    var form = section.querySelector('form[data-product-form]');
    if (addonsBox && form && addBtn) {
      var sending = false;
      addBtn.addEventListener('click', function (e) {
        var picked = Array.prototype.filter.call(addonsBox.querySelectorAll('[data-addon-variant]'), function (c) { return c.checked; });
        if (!picked.length || sending) return;
        e.preventDefault(); e.stopImmediatePropagation(); sending = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: picked.map(function (c) { return { id: +c.getAttribute('data-addon-variant'), quantity: 1 }; }) }) })
          .catch(function () {})
          .then(function () { picked.forEach(function (c) { c.checked = false; }); if (form.requestSubmit) form.requestSubmit(addBtn); else form.submit(); sending = false; });
      }, true);
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["focus-models"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // Karusel sam polako klizi udesno (beskonacna petlja preko kloniranih kartica),
    // a staje cim korisnik dodirne, zadrzi mis ili pomeri sam. Posle pauze nastavlja.
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-fm]').forEach(function(wrap) {
      var track = wrap.querySelector('[data-fm-track]');
      var prev = wrap.querySelector('[data-fm-prev]');
      var next = wrap.querySelector('[data-fm-next]');
      var bar = wrap.querySelector('[data-fm-progress]');
      if (!track) return;

      var cards = Array.prototype.slice.call(track.querySelectorAll('.fm__card'));
      var looping = !reduce && cards.length > 1;
      if (looping) {
        cards.forEach(function(c) {
          var k = c.cloneNode(true);
          k.setAttribute('aria-hidden', 'true');
          k.removeAttribute('data-reveal');
          k.classList.add('is-in');
          k.querySelectorAll('a, button').forEach(function(a) { a.setAttribute('tabindex', '-1'); });
          track.appendChild(k);
        });
      }

      function half() { return looping ? track.scrollWidth / 2 : track.scrollWidth; }
      function step() {
        var c = track.querySelector('.fm__card');
        return c ? c.getBoundingClientRect().width + 20 : 320;
      }
      function update() {
        var h = half();
        var pos = looping ? track.scrollLeft % h : track.scrollLeft;
        var visible = Math.min(1, track.clientWidth / h);
        var w = Math.max(10, visible * 100);
        if (bar) {
          bar.style.width = w + '%';
          bar.style.transform = 'translateX(' + ((pos / h) * (100 / w) * 100) + '%)';
        }
        if (!looping) {
          var max = track.scrollWidth - track.clientWidth;
          if (prev) prev.disabled = track.scrollLeft <= 2;
          if (next) next.disabled = track.scrollLeft >= max - 2;
        }
      }

      // Auto klizanje
      var paused = false, inView = true, idle = null, userScrolling = false;
      var SPEED = 0.45; // px po frejmu, oko 27 px/s

      function setAuto(on) {
        track.classList.toggle('fm__track--auto', on);
      }
      function pause(ms) {
        paused = true;
        setAuto(false);
        clearTimeout(idle);
        if (ms) idle = setTimeout(function() { paused = false; setAuto(true); }, ms);
      }
      function resume() { clearTimeout(idle); idle = setTimeout(function() { paused = false; setAuto(true); }, 1200); }

      if (looping) {
        setAuto(true);
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function(en) { inView = en[0].isIntersecting; }, { threshold: 0.1 }).observe(wrap);
        }
        // Pozicija se vodi kao decimalni broj jer browser zaokruzuje scrollLeft na cele piksele
        var pos = track.scrollLeft;
        function frame() {
          if (!paused && inView && !document.hidden && !userScrolling) {
            var h = half();
            pos += SPEED;
            if (pos >= h) pos -= h;
            track.scrollLeft = pos;
          } else {
            pos = track.scrollLeft;
          }
          requestAnimationFrame(frame);
        }
        requestAnimationFrame(frame);

        // Mis: stani dok je preko karusela
        wrap.addEventListener('pointerenter', function(e) { if (e.pointerType === 'mouse') { paused = true; setAuto(false); } });
        wrap.addEventListener('pointerleave', function(e) { if (e.pointerType === 'mouse') resume(); });
        // Prst ili tockic: stani, pa nastavi posle pauze
        track.addEventListener('touchstart', function() { userScrolling = true; pause(); }, { passive: true });
        track.addEventListener('touchend', function() { userScrolling = false; pause(2500); }, { passive: true });
        track.addEventListener('wheel', function() { userScrolling = true; pause(2500); clearTimeout(track.__w); track.__w = setTimeout(function() { userScrolling = false; }, 300); }, { passive: true });
        wrap.addEventListener('focusin', function() { pause(); });
        wrap.addEventListener('focusout', function() { resume(); });
      }

      prev && prev.addEventListener('click', function() { pause(3000); track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next && next.addEventListener('click', function() { pause(3000); track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["friends"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('.fr');
    if (!section || section.__bb) return;
    section.__bb = true;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var buttons = Array.prototype.slice.call(section.querySelectorAll('[data-fr-open]'));

    /* Telefon: samo jedan video svira, i to onaj koji je najvise u ekranu */
    var isPhone = window.matchMedia && window.matchMedia('(max-width: 699px)').matches;

    /* Stedljiv rezim ili spora veza: bez automatskog pustanja, ostaje samo slicica */
    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    var saveData = !!(conn && (conn.saveData || /(^|-)(2g|slow-2g)$/.test(conn.effectiveType || '')));
    var autoplay = !reduce && !saveData && 'IntersectionObserver' in window;

    /* Safari i iOS umeju HLS, koji sam bira kvalitet prema brzini veze. Ostali dobijaju mp4. */
    function pick(el, mp4Attr, hlsAttr) {
      var hls = el.getAttribute(hlsAttr);
      if (hls && el.canPlayType && el.canPlayType('application/vnd.apple.mpegurl')) return hls;
      return el.getAttribute(mp4Attr) || hls || '';
    }
    function load(v) {
      if (!v.src) v.src = pick(v, 'data-src', 'data-hls');
    }
    function pauseAll(except) {
      buttons.forEach(function (b) {
        var vid = b.querySelector('[data-fr-video]');
        if (vid && vid !== except && !vid.paused) vid.pause();
      });
    }

    buttons.forEach(function (btn) { btn.classList.add('is-idle'); });

    if (!autoplay) {
      /* Bez automatskog pustanja i dalje treba prikazati slicicu, pa se video ne skida uopste */
      buttons.forEach(function (btn) { btn.classList.add('is-idle'); });
    } else if (isPhone) {
      var ratios = new Map();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { ratios.set(e.target, e.intersectionRatio); });
        var best = null, bestRatio = 0.5;
        ratios.forEach(function (r, el) { if (r > bestRatio) { bestRatio = r; best = el; } });
        if (!best) { pauseAll(null); return; }
        var v = best.querySelector('[data-fr-video]');
        if (!v) return;
        pauseAll(v);
        load(v);
        var p = v.play();
        if (p && p.then) p.then(function () { best.classList.remove('is-idle'); }).catch(function () {});
      }, { threshold: [0, 0.25, 0.5, 0.75, 1] });
      buttons.forEach(function (btn) { io.observe(btn); });
    } else {
      buttons.forEach(function (btn) {
        var v = btn.querySelector('[data-fr-video]');
        if (!v) return;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              load(v);
              var p = v.play();
              if (p && p.then) p.then(function () { btn.classList.remove('is-idle'); }).catch(function () {});
            } else if (!v.paused) {
              v.pause();
            }
          });
        }, { threshold: 0.35 });
        io.observe(btn);
      });
    }

    /* Kad korisnik ode sa kartice, sve se pauzira da ne trosi bateriju */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) pauseAll(null);
    });

    /* Zvuk na klik: svira samo jedan sa zvukom, ostali ostaju bez zvuka.
       Video se ne otvara nigde, ostaje u kartici. */
    function setSound(btn, on) {
      var v = btn.querySelector('[data-fr-video]');
      if (!v) return;
      v.muted = !on;
      btn.classList.toggle('is-sound', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    function muteOthers(except) {
      buttons.forEach(function (b) { if (b !== except && b.classList.contains('is-sound')) setSound(b, false); });
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = btn.querySelector('[data-fr-video]');
        if (!v) return;
        var on = !btn.classList.contains('is-sound');
        muteOthers(btn);
        setSound(btn, on);
        load(v);
        /* Sa zvukom krece od pocetka, da se cuje cela poruka. Ostali nastavljaju bez zvuka. */
        if (on) v.currentTime = 0;
        var p = v.play();
        if (p && p.then) p.then(function () { btn.classList.remove('is-idle'); }).catch(function () {});
      });
    });

    /* Kad video sa zvukom izadje iz ekrana ili se pauzira, zvuk se gasi da ne svira "iz cosa" */
    buttons.forEach(function (btn) {
      var v = btn.querySelector('[data-fr-video]');
      if (v) v.addEventListener('pause', function () { if (btn.classList.contains('is-sound')) setSound(btn, false); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    /* These overlays live OUTSIDE <header> (moved out so the header's
       backdrop-filter doesn't trap their position:fixed). Query from document. */
    var backdrop = document.querySelector('[data-header-backdrop]');
    var drawer = document.querySelector('[data-drawer]');
    var drawerToggle = header.querySelector('[data-menu-toggle]');
    var drawerClose = document.querySelector('[data-drawer-close]');
    var searchPanel = document.querySelector('[data-search-panel]');
    var searchToggle = header.querySelector('[data-search-toggle]');
    var searchClose = document.querySelector('[data-search-close]');
    var searchInput = document.querySelector('[data-search-input]');
    var searchResults = document.querySelector('[data-search-results]');

    function showBackdrop() { backdrop && backdrop.classList.add('header__backdrop--visible'); }
    function hideBackdrop() { backdrop && backdrop.classList.remove('header__backdrop--visible'); }

    /* Drawer */
    function openDrawer() {
      if (!drawer) return;
      drawer.setAttribute('aria-hidden', 'false');
      drawerToggle && drawerToggle.setAttribute('aria-expanded', 'true');
      showBackdrop();
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.setAttribute('aria-hidden', 'true');
      drawerToggle && drawerToggle.setAttribute('aria-expanded', 'false');
      hideBackdrop();
      document.body.style.overflow = '';
    }

    drawerToggle && drawerToggle.addEventListener('click', function() {
      drawer.getAttribute('aria-hidden') === 'false' ? closeDrawer() : openDrawer();
    });
    drawerClose && drawerClose.addEventListener('click', closeDrawer);

    /* Search overlay */
    function openSearch() {
      if (!searchPanel) return;
      closeDrawer();
      closeCart();
      closeLang();
      searchPanel.setAttribute('aria-hidden', 'false');
      showBackdrop();
      setTimeout(function() { searchInput && searchInput.focus(); }, 60);
    }
    function closeSearch() {
      if (!searchPanel) return;
      searchPanel.setAttribute('aria-hidden', 'true');
      if (drawer && drawer.getAttribute('aria-hidden') !== 'false') hideBackdrop();
    }

    searchToggle && searchToggle.addEventListener('click', openSearch);
    searchClose && searchClose.addEventListener('click', closeSearch);

    /* Predictive search */
    var searchTimer = null;
    function doPredictiveSearch(q) {
      if (!q || q.length < 2) { searchResults.innerHTML = ''; return; }
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6';
      fetch(url).then(function(r) { return r.json(); }).then(function(data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) {
          searchResults.innerHTML = '<div class="header__search-empty">Nema rezultata za "' + q.replace(/[<>&"]/g, '') + '"</div>';
          return;
        }
        var html = products.map(function(p) {
          var img = p.image ? '<img class="header__search-result-img" src="' + p.image + '" alt="' + String(p.title || '').replace(/"/g, '') + '" loading="lazy">' : '<div class="header__search-result-img"></div>';
          var price = p.price ? '<span class="header__search-result-price">' + p.price + '</span>' : '';
          return '<a class="header__search-result" href="' + p.url + '">' +
            img +
            '<div class="header__search-result-info">' +
              '<div class="header__search-result-title">' + p.title + '</div>' +
              price +
            '</div></a>';
        }).join('');
        searchResults.innerHTML = html;
      }).catch(function() { /* silent */ });
    }

    searchInput && searchInput.addEventListener('input', function(e) {
      clearTimeout(searchTimer);
      var q = e.target.value;
      searchTimer = setTimeout(function() { doPredictiveSearch(q); }, 200);
    });

    /* Backdrop click closes everything */
    backdrop && backdrop.addEventListener('click', function() {
      closeDrawer();
      closeSearch();
    });

    /* ESC closes overlays */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') { closeDrawer(); closeSearch(); closeCart(); closeLang(); }
    });

    /* Cart flyout */
    var cartBtn = header.querySelector('[data-cart-btn]');
    var cartFlyout = header.querySelector('[data-cart-flyout]');
    var cartClose = header.querySelector('[data-cart-close]');

    function openCart() {
      if (!cartFlyout) return;
      cartFlyout.classList.add('header__cart-flyout--open');
      cartBtn && cartBtn.setAttribute('aria-expanded', 'true');
    }
    function closeCart() {
      if (!cartFlyout) return;
      cartFlyout.classList.remove('header__cart-flyout--open');
      cartBtn && cartBtn.setAttribute('aria-expanded', 'false');
    }

    if (cartBtn && cartFlyout) {
      cartBtn.addEventListener('click', function() {
        cartBtn.getAttribute('aria-expanded') === 'true' ? closeCart() : openCart();
      });
      if (cartClose) cartClose.addEventListener('click', closeCart);
    }

    /* Language dropdown */
    var langBtn = header.querySelector('[data-lang-btn]');
    var langDropdown = header.querySelector('[data-lang-dropdown]');

    function openLang() {
      if (!langDropdown) return;
      langDropdown.classList.add('header__lang-dropdown--open');
      langBtn && langBtn.setAttribute('aria-expanded', 'true');
    }
    function closeLang() {
      if (!langDropdown) return;
      langDropdown.classList.remove('header__lang-dropdown--open');
      langBtn && langBtn.setAttribute('aria-expanded', 'false');
    }

    if (langBtn && langDropdown) {
      langBtn.addEventListener('click', function() {
        langBtn.getAttribute('aria-expanded') === 'true' ? closeLang() : openLang();
      });
    }

    /* Close cart/lang on outside click */
    document.addEventListener('click', function(e) {
      if (header.contains(e.target)) {
        var cartWrap = header.querySelector('[data-cart-toggle]');
        var langWrap = header.querySelector('[data-lang-toggle]');
        if (cartWrap && !cartWrap.contains(e.target)) closeCart();
        if (langWrap && !langWrap.contains(e.target)) closeLang();
      }
    });

    /* Scroll behavior: shadow + shrink + hide action-bar */
    var scrolled = false;
    var actionBar = document.querySelector('.action-bar');
    if (actionBar && actionBar.parentElement) actionBar = actionBar.parentElement;
    window.addEventListener('scroll', function() {
      var shouldBeScrolled = window.scrollY > 10;
      if (shouldBeScrolled !== scrolled) {
        scrolled = shouldBeScrolled;
        header.classList.toggle('header--scrolled', scrolled);
        document.body.classList.toggle('body--scrolled', scrolled);
      }
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // Video pozadina. Ima autoplay atribut da krene sam i bez JS-a; ovaj kod je
    // pojas i tregeri — gura play() ako ga browser nije pokrenuo, i drzi video
    // ugasenim na telefonu da se ne skida 15 MB.
    var v = document.querySelector('[data-hero-video]');
    if (v && window.matchMedia) {
      var mqDesktop = window.matchMedia('(min-width: 768px)');

      var start = function() {
        if (!mqDesktop.matches || !v.paused) return;
        // Bez v.load() — sa preload="none" play() sam pokrece ucitavanje,
        // a load() bi prekinuo reprodukciju u toku (AbortError).
        var p = v.play();
        if (p && p.catch) p.catch(function() { /* odbijen — ostaje poster slika */ });
      };

      var stopMobile = function() {
        if (mqDesktop.matches) return;
        v.removeAttribute('autoplay');
        if (!v.paused) v.pause();
      };

      stopMobile();
      start();

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function(entries) {
          entries.forEach(function(e) { if (e.isIntersecting) start(); });
        }, { rootMargin: '200px' });
        io.observe(v);
      }

      // Prelazak preko granice 768px u oba smera
      var onChange = function() { if (mqDesktop.matches) start(); else stopMobile(); };
      if (mqDesktop.addEventListener) mqDesktop.addEventListener('change', onChange);
      else if (mqDesktop.addListener) mqDesktop.addListener(onChange);

      // Ne trosi bateriju i podatke dok je tab u pozadini
      document.addEventListener('visibilitychange', function() {
        if (document.hidden) { if (!v.paused) v.pause(); }
        else { start(); }
      });
    }

    var slideshow = document.querySelector('[data-hero-slideshow]');
    if (slideshow) {
      var slides = slideshow.querySelectorAll('[data-hero-slide]');
      var dots = slideshow.querySelectorAll('[data-hero-dot]');
      var autoplay = parseInt(slideshow.getAttribute('data-autoplay'), 10) || 0;
      if (slides.length > 1) {
        var current = 0;
        var timer = null;

        function go(i) {
          slides[current].classList.remove('hero__slide--active');
          if (dots[current]) dots[current].classList.remove('hero__dot--active');
          current = (i + slides.length) % slides.length;
          slides[current].classList.add('hero__slide--active');
          if (dots[current]) dots[current].classList.add('hero__dot--active');
        }

        function start() {
          if (autoplay > 0) {
            stop();
            timer = setInterval(function() { go(current + 1); }, autoplay);
          }
        }

        function stop() {
          if (timer) { clearInterval(timer); timer = null; }
        }

        dots.forEach(function(dot) {
          dot.addEventListener('click', function() {
            go(parseInt(dot.getAttribute('data-hero-dot'), 10));
            start();
          });
        });

        slideshow.addEventListener('mouseenter', stop);
        slideshow.addEventListener('mouseleave', start);
        start();
      }
    }

    var calc = document.querySelector('[data-hero-calc]');
    if (!calc) return;

    var kmInput = calc.querySelector('[data-hcalc-km]');
    var gasInput = calc.querySelector('[data-hcalc-gas]');
    var kmDisplay = calc.querySelector('[data-hcalc-km-display]');
    var gasDisplay = calc.querySelector('[data-hcalc-gas-display]');
    var monthlyEl = calc.querySelector('[data-hcalc-monthly]');
    var yearlyEl = calc.querySelector('[data-hcalc-yearly]');
    var presetBtns = calc.querySelectorAll('[data-preset]');

    var consumption = 9;
    var ELECTRIC_COST_PER_KM = 0.5;

    function fmt(n) {
      return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    function calculate() {
      var km = parseInt(kmInput.value, 10);
      var gas = parseInt(gasInput.value, 10);
      kmDisplay.textContent = km + ' km';
      gasDisplay.textContent = gas + ' RSD';

      var mKm = km * 30;
      var yKm = km * 365;
      var mSave = (mKm * consumption / 100) * gas - mKm * ELECTRIC_COST_PER_KM;
      var ySave = (yKm * consumption / 100) * gas - yKm * ELECTRIC_COST_PER_KM;

      monthlyEl.textContent = fmt(mSave) + ' RSD';
      yearlyEl.textContent = fmt(ySave) + ' RSD';
    }

    presetBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        presetBtns.forEach(function(b) { b.classList.remove('hero__calc-preset--active'); });
        btn.classList.add('hero__calc-preset--active');
        consumption = parseInt(btn.getAttribute('data-consumption'), 10);
        calculate();
      });
    });

    kmInput.addEventListener('input', calculate);
    gasInput.addEventListener('input', calculate);
    calculate();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var root = document.querySelector('[data-hh]');
    if (!root) return;

    // Video samo na desktopu; na telefonu ostaju slajdovi i nista se ne skida
    var v = root.querySelector('[data-hh-video]');
    if (v && window.matchMedia) {
      var mq = window.matchMedia('(min-width: 768px)');
      var start = function() {
        if (!mq.matches || !v.paused) return;
        var p = v.play();
        if (p && p.catch) p.catch(function() {});
      };
      var stopMobile = function() {
        if (mq.matches) return;
        v.removeAttribute('autoplay');
        if (!v.paused) v.pause();
      };
      stopMobile(); start();
      var onChange = function() { if (mq.matches) start(); else stopMobile(); };
      if (mq.addEventListener) mq.addEventListener('change', onChange); else if (mq.addListener) mq.addListener(onChange);
      document.addEventListener('visibilitychange', function() { if (document.hidden) { if (!v.paused) v.pause(); } else start(); });
    }

    // Slajdovi
    var slides = root.querySelectorAll('[data-hh-slide]');
    var dots = root.querySelectorAll('[data-hh-dot]');
    var autoplay = parseInt(root.getAttribute('data-autoplay'), 10) || 0;
    if (slides.length > 1) {
      var cur = 0, timer = null;
      function go(i) {
        slides[cur].classList.remove('hh__slide--active');
        if (dots[cur]) dots[cur].classList.remove('hh__dot--active');
        cur = (i + slides.length) % slides.length;
        slides[cur].classList.add('hh__slide--active');
        if (dots[cur]) dots[cur].classList.add('hh__dot--active');
      }
      function run() { if (autoplay > 0) { clearInterval(timer); timer = setInterval(function() { go(cur + 1); }, autoplay); } }
      dots.forEach(function(d) { d.addEventListener('click', function() { go(parseInt(d.getAttribute('data-hh-dot'), 10)); run(); }); });
      run();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["installments-page"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-ip]');
    if (!root) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ── Otkrivanje pri skrolu ── */
    var revealables = root.querySelectorAll('.reveal');
    if (reduce || !('IntersectionObserver' in window)) {
      revealables.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var ro = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-visible'); ro.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      revealables.forEach(function (el) { ro.observe(el); });
    }

    function fmt(n) {
      return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    function animateTo(el, from, to, dur, suffix) {
      if (reduce) { el.textContent = fmt(to) + (suffix || ''); return; }
      var t0 = null;
      function step(ts) {
        if (!t0) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = fmt(from + (to - from) * eased) + (suffix || '');
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    /* ── Brojevi u hero-u ── */
    var stats = root.querySelectorAll('[data-count-to]');
    if ('IntersectionObserver' in window && !reduce) {
      var so = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target;
          animateTo(el, 0, parseFloat(el.getAttribute('data-count-to')), 900, el.getAttribute('data-suffix'));
          so.unobserve(el);
        });
      }, { threshold: 0.5 });
      stats.forEach(function (el) { so.observe(el); });
    }

    /* ── Kalkulator ──
       Ista PMT formula koja se koristi na karticama proizvoda, da se iznosi poklapaju. */
    var RATE = parseFloat(root.getAttribute('data-rate') || '0.9125') / 100;
    var N = parseInt(root.getAttribute('data-months') || '24', 10);

    var picks = root.querySelectorAll('[data-ip-pick]');
    var nameEl = root.querySelector('[data-ip-name]');
    var monthlyEl = root.querySelector('[data-ip-monthly]');
    var priceEl = root.querySelector('[data-ip-price]');
    var ctaEl = root.querySelector('[data-ip-cta]');
    if (!picks.length || !monthlyEl) return;

    var factor = (function (r, n) {
      if (r === 0) return 1 / n;
      var f = Math.pow(1 + r, n);
      return r * f / (f - 1);
    })(RATE, N);

    var last = 0;

    function select(btn, animate) {
      picks.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });

      var price = parseFloat(btn.getAttribute('data-price') || '0') / 100;
      var monthly = price * factor;

      if (nameEl) nameEl.textContent = btn.getAttribute('data-name') || '';
      if (priceEl) priceEl.textContent = fmt(price) + ' RSD';
      if (ctaEl) ctaEl.setAttribute('href', btn.getAttribute('data-url') || '#');

      if (animate) animateTo(monthlyEl, last, monthly, 420);
      else monthlyEl.textContent = fmt(monthly);
      last = monthly;
    }

    picks.forEach(function (b) {
      b.addEventListener('click', function () { select(b, true); });
    });

    select(picks[0], false);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["installments-teaser"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-it-calc]').forEach(function(calc) {
      var picks = calc.querySelectorAll('[data-it-pick]');
      var amount = calc.querySelector('[data-it-amount]');
      var name = calc.querySelector('[data-it-name]');
      var current = 0;
      function fmt(n) { return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
      function pmt(price) {
        if (window.bb && window.bb.monthly) return window.bb.monthly(price);
        var r = parseFloat(window.BB_RATE || '0.9125') / 100, n = parseInt(window.BB_MONTHS || '24', 10);
        var f = Math.pow(1 + r, n); return price * r * f / (f - 1);
      }
      function select(btn, animate) {
        picks.forEach(function(b) { b.classList.toggle('it__pick--active', b === btn); });
        // Ista rata kao na stranici modela (računa je tema iz žive cene); JS formula je samo rezerva
        var live = parseFloat(btn.getAttribute('data-monthly') || '');
        var to = live > 0 ? live : pmt(parseFloat(btn.getAttribute('data-price') || '0'));
        var full = calc.querySelector('[data-it-full]'); if (full) full.textContent = btn.getAttribute('data-full') || '';
        if (name) name.textContent = btn.getAttribute('data-name') || '';
        if (window.bb && window.bb.tween && animate) window.bb.tween(amount, current, to, 500);
        else amount.textContent = fmt(to);
        current = to;
      }
      picks.forEach(function(b) { b.addEventListener('click', function() { select(b, true); }); });
      if (picks.length) select(picks[0], false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["locations"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var cards = document.querySelectorAll('[data-location-card]');
    var mapFrame = document.querySelector('[data-locations-map]');
    if (!cards.length || !mapFrame) return;

    var baseSrc = mapFrame.src;
    var keyMatch = baseSrc.match(/key=([^&]+)/);
    if (!keyMatch) return;
    var apiKey = keyMatch[1];

    cards.forEach(function(card) {
      card.addEventListener('click', function(e) {
        if (e.target.closest('a')) return;

        cards.forEach(function(c) { c.classList.remove('locations__card--active'); });
        card.classList.add('locations__card--active');

        var query = card.getAttribute('data-map-query');
        mapFrame.src = 'https://www.google.com/maps/embed/v1/place?key=' + apiKey + '&q=' + query + '&zoom=15';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["model-quiz"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-qz]').forEach(function(box) {
      var steps = Array.prototype.slice.call(box.querySelectorAll('[data-qz-step]'));
      var result = box.querySelector('[data-qz-result]');
      var models = Array.prototype.slice.call(box.querySelectorAll('[data-qz-model]'));
      var fill = box.querySelector('[data-qz-fill]');
      var count = box.querySelector('[data-qz-count]');
      var back = box.querySelector('[data-qz-back]');
      var n = steps.length;
      var cur = 0;
      var picks = [];
      var pad = function(x) { return (x < 10 ? '0' : '') + x; };

      function head(i, done) {
        if (fill) fill.style.width = (done ? 100 : Math.round((i + 1) / n * 100)) + '%';
        if (count) count.innerHTML = done ? '<span>Gotovo</span>' : pad(i + 1) + ' <em>/ ' + pad(n) + '</em>';
        if (back) back.hidden = done ? false : i === 0;
      }

      function show(i) {
        cur = i;
        steps.forEach(function(s, k) { s.classList.toggle('qz__step--on', k === i); });
        result.classList.remove('qz__step--on');
        head(i, false);
      }

      function finish() {
        cur = n;
        var total = picks.length || 1;
        // Odlucujuca pitanja (npr. skuter / bicikl / trotinet / tricikl) izbacuju modele bez tog kljuca,
        // osim ako nijedan model ne bi ostao.
        var pool = models.slice();
        steps.forEach(function(step, i) {
          if (step.getAttribute('data-decisive') !== 'true' || !picks[i]) return;
          var kept = pool.filter(function(m) { return (m.getAttribute('data-keys') || '').indexOf(',' + picks[i] + ',') !== -1; });
          if (kept.length) pool = kept;
        });
        var scored = pool.map(function(m) {
          var keys = m.getAttribute('data-keys') || '';
          var hits = picks.filter(function(k) { return keys.indexOf(',' + k + ',') !== -1; }).length;
          return { el: m, hits: hits, order: parseInt(m.getAttribute('data-order'), 10) };
        }).sort(function(a, b) { return b.hits - a.hits || a.order - b.order; });

        // Modeli van izbora idu na kraj liste "ostalih"
        var rest = models.filter(function(m) { return pool.indexOf(m) === -1; }).map(function(m) {
          return { el: m, hits: 0, order: parseInt(m.getAttribute('data-order'), 10) };
        });
        var all = scored.concat(rest);

        var top = box.querySelector('[data-qz-results]');
        var others = box.querySelector('[data-qz-others]');
        var othersWrap = box.querySelector('[data-qz-others-wrap]');
        var labels = ['Najbolji izbor', 'Druga opcija', 'Treća opcija'];

        all.forEach(function(s, i) {
          var pct = Math.round(s.hits / total * 100);
          var el = s.el;
          el.hidden = false;
          el.classList.toggle('qz__card--top', i === 0);
          el.classList.toggle('qz__card--other', i >= 3);
          var r = el.querySelector('[data-qz-rank]'); if (r) r.textContent = i < 3 ? labels[i] : '';
          var t = el.querySelector('[data-qz-match-text]'); if (t) t.textContent = pct + '%';
          var bar = el.querySelector('[data-qz-match-bar]');
          if (bar) { bar.style.width = '0'; setTimeout(function() { bar.style.width = pct + '%'; }, 60); }
          (i < 3 ? top : others).appendChild(el);
        });
        if (othersWrap) othersWrap.hidden = all.length <= 3;

        steps.forEach(function(s) { s.classList.remove('qz__step--on'); });
        result.classList.add('qz__step--on');
        head(n - 1, true);
        var y = box.getBoundingClientRect().top + window.pageYOffset - 90;
        if (box.getBoundingClientRect().top < 0) window.scrollTo({ top: y, behavior: 'smooth' });
      }

      steps.forEach(function(step, i) {
        step.querySelectorAll('[data-qz-answer]').forEach(function(btn) {
          btn.addEventListener('click', function() {
            step.querySelectorAll('[data-qz-answer]').forEach(function(b) { b.classList.remove('qz__answer--picked'); });
            btn.classList.add('qz__answer--picked');
            picks[i] = btn.getAttribute('data-key');
            setTimeout(function() {
              if (i + 1 < n) show(i + 1); else finish();
            }, 220);
          });
        });
      });

      if (back) back.addEventListener('click', function() { show(Math.max(0, cur - 1)); });

      var restart = box.querySelector('[data-qz-restart]');
      if (restart) restart.addEventListener('click', function() {
        picks = [];
        box.querySelectorAll('.qz__answer--picked').forEach(function(b) { b.classList.remove('qz__answer--picked'); });
        show(0);
        box.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-pfq-item]').forEach(function(item) {
      var body = item.querySelector('[data-pfq-body]');
      var summary = item.querySelector('summary');
      if (!body || !summary || reduce) return;
      body.style.transition = 'height .35s cubic-bezier(.2,.7,.2,1)';
      summary.addEventListener('click', function(e) {
        e.preventDefault();
        if (item.open) {
          body.style.height = body.scrollHeight + 'px';
          requestAnimationFrame(function() { body.style.height = '0px'; });
          body.addEventListener('transitionend', function done() { item.open = false; body.style.height = ''; body.removeEventListener('transitionend', done); });
        } else {
          item.open = true;
          var h = body.scrollHeight;
          body.style.height = '0px';
          requestAnimationFrame(function() { body.style.height = h + 'px'; });
          body.addEventListener('transitionend', function done() { body.style.height = ''; body.removeEventListener('transitionend', done); });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var box = document.querySelector('[data-prec]');
    if (!box || box.__bb) return;
    box.__bb = true;
    var url = box.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function(r) { return r.text(); }).then(function(html) {
      var doc = document.createElement('div');
      doc.innerHTML = html;
      var fresh = doc.querySelector('[data-prec]');
      if (!fresh || !fresh.innerHTML.trim()) return;
      box.innerHTML = fresh.innerHTML;
      box.querySelectorAll('[data-reveal]').forEach(function(el) { el.classList.add('is-in'); });
      box.querySelectorAll('[data-bb-monthly]').forEach(function(el) {
        var price = parseFloat(el.getAttribute('data-price') || '0');
        if (price > 0 && window.bb) el.textContent = window.bb.fmt(window.bb.monthly(price));
      });
    }).catch(function() {});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      (root || document).querySelectorAll('.prv').forEach(function (sec) {
        if (sec.__bb) return; sec.__bb = true;
        var lb = sec.querySelector('[data-prv-lb]'), lbImg = sec.querySelector('[data-prv-lb-img]'), cnt = sec.querySelector('[data-prv-count]');
        var list = [], at = 0;

        // Istaknuta: prva slika vidljiva, sličice menjaju glavnu
        var hero = sec.querySelector('.prv__hero');
        if (hero) {
          var slides = hero.querySelectorAll('.prv__hero-img'), main = hero.querySelector('[data-prv-open]');
          var show = function (i) {
            slides.forEach(function (s, j) { s.classList.toggle('is-on', j === i); });
            hero.querySelectorAll('[data-prv-thumb]').forEach(function (t, j) { t.classList.toggle('is-on', j === i); });
            main.setAttribute('data-prv-open', i);
          };
          show(0);
          hero.querySelectorAll('[data-prv-thumb]').forEach(function (t) {
            t.addEventListener('click', function () { show(+t.getAttribute('data-prv-thumb')); });
          });
        }

        function paint() {
          var s = list[at]; if (!s) return;
          lbImg.src = s.src; lbImg.alt = s.alt || '';
          cnt.textContent = list.length > 1 ? (at + 1) + ' / ' + list.length : '';
          sec.querySelectorAll('.prv__lb-nav').forEach(function (b) { b.hidden = list.length < 2; });
        }
        sec.querySelectorAll('[data-prv-open]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var g = btn.closest('[data-prv-group]');
            list = Array.prototype.map.call(g.querySelectorAll('[data-prv-slide]'), function (el) {
              return { src: el.getAttribute('data-prv-full'), alt: el.getAttribute('data-prv-alt') || el.getAttribute('alt') };
            });
            at = +btn.getAttribute('data-prv-open') || 0;
            paint();
            if (lb.showModal) lb.showModal(); else lb.setAttribute('open', '');
          });
        });
        function step(d) { at = (at + d + list.length) % list.length; paint(); }
        sec.querySelector('[data-prv-prev]').addEventListener('click', function () { step(-1); });
        sec.querySelector('[data-prv-next]').addEventListener('click', function () { step(1); });
        sec.querySelector('[data-prv-close]').addEventListener('click', function () { lb.close(); });
        lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });
        lb.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') step(-1); if (e.key === 'ArrowRight') step(1); });
        var x0 = null;
        lb.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        lb.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1); x0 = null; });

        // "Prikaži još": na telefonu po 5 kartica, na računaru ostatak odjednom
        var more = sec.querySelector('[data-prv-more]');
        var lim = parseInt(sec.getAttribute('data-limit') || '0', 10);
        if (more && lim > 0) {
          var cards = Array.prototype.slice.call(sec.querySelectorAll('.prv__wall .prv__card'));
          var mobile = window.matchMedia('(max-width: 699px)').matches;
          var shown = mobile ? 5 : lim, step = mobile ? 5 : cards.length;
          var paint = function () {
            cards.forEach(function (c, i) { c.classList.toggle('prv__card--more', i >= shown); });
            var left = cards.length - shown;
            more.parentElement.hidden = left <= 0;
            more.textContent = 'Prikaži još ' + Math.min(step, left) + (Math.min(step, left) === 1 ? ' recenziju' : ' recenzija');
            toggles();
          };
          more.addEventListener('click', function () { shown += step; paint(); });
          setTimeout(paint, 0);
        }

        // Duge recenzije (samo vidljive kartice; skrivene se obrade kad se prikažu)
        function toggles() { sec.querySelectorAll('[data-prv-toggle]').forEach(function (b) {
          if (b.__bb || !b.offsetParent && !b.parentElement.offsetParent) return;
          b.__bb = true;
          var q = b.parentElement.querySelector('[data-prv-quote]');
          if (q.scrollHeight <= q.clientHeight + 2) { b.hidden = true; q.classList.remove('is-clamped'); return; }
          b.addEventListener('click', function () {
            var open = q.classList.toggle('is-clamped') === false;
            b.textContent = open ? 'Prikaži manje' : 'Prikaži celu recenziju';
          });
        }); }
        toggles();
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var frame = document.querySelector('[data-pv-open]');
    var box = document.querySelector('[data-pv-lightbox]');
    if (!frame || !box || frame.__bb) return;
    frame.__bb = true;

    var video = frame.querySelector('[data-pv-video]');
    var lb = box.querySelector('[data-pv-lb-video]');
    /* Video se pusta i kad je ukljuceno smanjenje animacija, jer je to prikaz proizvoda,
       a ne ukrasna pozadina. Stedljiv rezim i spora veza i dalje zaustavljaju skidanje. */
    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    var saveData = !!(conn && (conn.saveData || /(^|-)(2g|slow-2g)$/.test(conn.effectiveType || '')));

    /* Safari i iOS umeju HLS, koji sam bira kvalitet prema brzini veze */
    function pick(el, mp4Attr, hlsAttr) {
      var hls = el.getAttribute(hlsAttr);
      if (hls && el.canPlayType && el.canPlayType('application/vnd.apple.mpegurl')) return hls;
      return el.getAttribute(mp4Attr) || hls || '';
    }

    if (video && !saveData) {
      var start = function () {
        if (!video.src) video.src = pick(video, 'data-src', 'data-hls');
        var p = video.play();
        if (p && p.then) p.then(function () { frame.classList.remove('is-idle'); }).catch(function () {});
      };

      /* Koliko je kadra u ekranu. Koristi se i za pustanje i za pauzu. */
      var visibleRatio = function () {
        var r = frame.getBoundingClientRect();
        if (!r.height) return 0;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        return Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, 0)) / r.height;
      };
      var sync = function () {
        if (visibleRatio() >= 0.3) start();
        else if (!video.paused) video.pause();
      };

      /* IntersectionObserver je glavni put, a merenje pri skrolu je rezerva
         za slucajeve kad observer ne javi (neki ugradjeni pregledaci). */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) start();
            else if (!video.paused) video.pause();
          });
        }, { threshold: 0.3 }).observe(frame);
      }

      /* Namerno setTimeout, a ne requestAnimationFrame: on stoji kad je kartica
         u pozadini, pa bi rezerva zakazala bas tamo gde treba da uskoci. */
      var ticking = false;
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        setTimeout(function () { ticking = false; sync(); }, 120);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      sync();
    }

    function close() {
      box.classList.remove('is-open');
      lb.pause();
      document.body.style.overflow = '';
      setTimeout(function () { box.hidden = true; lb.removeAttribute('src'); lb.load(); }, 200);
    }

    frame.addEventListener('click', function () {
      if (video && !video.paused) video.pause();
      lb.setAttribute('data-full', frame.getAttribute('data-full') || '');
      lb.setAttribute('data-full-hls', frame.getAttribute('data-full-hls') || '');
      lb.src = pick(lb, 'data-full', 'data-full-hls');
      box.hidden = false;
      requestAnimationFrame(function () { box.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
      var p = lb.play();
      if (p && p.catch) p.catch(function () {});
    });

    box.querySelector('[data-pv-close]').addEventListener('click', close);
    box.addEventListener('click', function (e) { if (e.target === box) close(); });
    document.addEventListener('keydown', function (e) { if (!box.hidden && e.key === 'Escape') close(); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden && video && !video.paused) video.pause();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    var section = document.querySelector('.pdp');
    if (!section || section.__bb) return;
    section.__bb = true;

    /* Kolicina */
    var qtyInput = section.querySelector('[data-qty-input]');
    var qtyMinus = section.querySelector('[data-qty-minus]');
    var qtyPlus = section.querySelector('[data-qty-plus]');
    if (qtyInput && qtyMinus && qtyPlus) {
      qtyMinus.addEventListener('click', function() { var v = parseInt(qtyInput.value, 10) || 1; if (v > 1) qtyInput.value = v - 1; });
      qtyPlus.addEventListener('click', function() { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; });
    }

    /* Izbor varijante */
    var variantSelect = section.querySelector('[data-variant-select]');
    var optionInputs = section.querySelectorAll('[data-option-input]');
    var addBtn = section.querySelector('[data-add-btn]');
    if (!variantSelect || !optionInputs.length) return;

    optionInputs.forEach(function(input) {
      input.addEventListener('change', function() {
        var parent = this.closest('.pdp__option-values');
        parent.querySelectorAll('.pdp__option-btn').forEach(function(b) { b.classList.remove('pdp__option-btn--active'); });
        this.closest('.pdp__option-btn').classList.add('pdp__option-btn--active');
        var cur = section.querySelector('[data-option-current="' + this.getAttribute('data-option-index') + '"]');
        if (cur) cur.textContent = this.value;

        var selected = [];
        section.querySelectorAll('[data-option-input]:checked').forEach(function(c) {
          selected[parseInt(c.getAttribute('data-option-index'), 10)] = c.value;
        });
        var options = variantSelect.querySelectorAll('option');
        for (var i = 0; i < options.length; i++) {
          var opt = options[i], match = true;
          for (var j = 0; j < selected.length; j++) {
            if (opt.getAttribute('data-option' + (j + 1)) !== selected[j]) { match = false; break; }
          }
          if (!match) continue;
          variantSelect.value = opt.value;
          var available = opt.getAttribute('data-available') === 'true';
          if (addBtn) {
            addBtn.disabled = !available;
            addBtn.textContent = available ? addBtn.getAttribute('data-label-add') : addBtn.getAttribute('data-label-sold');
          }
          var vImg = opt.getAttribute('data-variant-image');
          if (vImg && window.bbSetMainImage) window.bbSetMainImage(vImg, vImg);
          var url = new URL(window.location.href);
          url.searchParams.set('variant', opt.value);
          history.replaceState(null, '', url.toString());
          break;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rate-float"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var bar = document.querySelector('[data-mbar]');
    if (!bar) return;
    var shown = false;
    function check() {
      var on = window.scrollY > window.innerHeight * 0.6;
      if (on !== shown) { shown = on; bar.classList.toggle('mbar--on', on); }
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["savings-calculator"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var calc = document.querySelector('[data-savings-calc]');
    if (!calc) return;

    var kmInput = calc.querySelector('[data-calc-km]');
    var gasInput = calc.querySelector('[data-calc-gas]');
    var consumptionInput = calc.querySelector('[data-calc-consumption]');
    var kmDisplay = calc.querySelector('[data-calc-km-display]');
    var gasDisplay = calc.querySelector('[data-calc-gas-display]');
    var consumptionDisplay = calc.querySelector('[data-calc-consumption-display]');
    var monthlyEl = calc.querySelector('[data-calc-monthly]');
    var yearlyEl = calc.querySelector('[data-calc-yearly]');
    var co2El = calc.querySelector('[data-calc-co2]');
    var presetButtons = calc.querySelectorAll('[data-preset]');

    var ELECTRIC_COST_PER_KM = 0.5;
    var CO2_PER_LITER = 2.31;

    function formatNumber(n) {
      return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    function calculate() {
      var dailyKm = parseInt(kmInput.value, 10);
      var gasPrice = parseInt(gasInput.value, 10);
      var consumption = parseFloat(consumptionInput.value);

      kmDisplay.textContent = dailyKm + ' km';
      gasDisplay.textContent = gasPrice + ' RSD';
      consumptionDisplay.textContent = consumption + ' L/100km';

      var monthlyKm = dailyKm * 30;
      var yearlyKm = dailyKm * 365;

      var monthlyGasCost = (monthlyKm * consumption / 100) * gasPrice;
      var monthlyElectricCost = monthlyKm * ELECTRIC_COST_PER_KM;
      var monthlySavings = monthlyGasCost - monthlyElectricCost;

      var yearlyGasCost = (yearlyKm * consumption / 100) * gasPrice;
      var yearlyElectricCost = yearlyKm * ELECTRIC_COST_PER_KM;
      var yearlySavings = yearlyGasCost - yearlyElectricCost;

      var yearlyCo2 = (yearlyKm * consumption / 100) * CO2_PER_LITER;

      monthlyEl.textContent = formatNumber(monthlySavings) + ' RSD';
      yearlyEl.textContent = formatNumber(yearlySavings) + ' RSD';
      co2El.textContent = formatNumber(yearlyCo2) + ' kg';
    }

    presetButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        presetButtons.forEach(function(b) { b.classList.remove('savings-calc__preset--active'); });
        btn.classList.add('savings-calc__preset--active');
        consumptionInput.value = btn.getAttribute('data-consumption');
        calculate();
      });
    });

    kmInput.addEventListener('input', calculate);
    gasInput.addEventListener('input', calculate);
    consumptionInput.addEventListener('input', calculate);

    calculate();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["specs-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll("[data-sg-items]").forEach(function (box) {
      var btn = box.parentElement.querySelector("[data-sg-more]");
      var n = box.querySelectorAll(".sg__item").length;
      if (!btn || n <= 4) { box.classList.remove("is-collapsed"); return; }
      btn.hidden = false; btn.textContent = "Prikaži sve specifikacije (" + n + ")";
      btn.addEventListener("click", function () { box.classList.remove("is-collapsed"); btn.hidden = true; });
    });
    // Broj u vrednosti (npr. "do 60 km" ili "48V / 15Ah") se broji od nule; tekst oko njega ostaje
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-sg-value]').forEach(function(el) {
      if (el.__bb) return;
      el.__bb = true;
      var text = el.textContent.trim();
      var m = text.match(/(\d+(?:[.,]\d+)?)/);
      if (!m || reduce || !window.bb) return;
      var num = parseFloat(m[1].replace(',', '.'));
      if (!isFinite(num) || num > 100000) return;
      var idx = m.index, pre = text.slice(0, idx), post = text.slice(idx + m[1].length);
      var span = document.createElement('span');
      el.textContent = '';
      el.appendChild(document.createTextNode(pre));
      el.appendChild(span);
      el.appendChild(document.createTextNode(post));
      var decimals = (m[1].split(/[.,]/)[1] || '').length;
      function run() {
        var t0 = null, dur = 1100;
        function step(ts) {
          if (!t0) t0 = ts;
          var p = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - p, 3);
          var v = num * e;
          span.textContent = decimals ? v.toFixed(decimals).replace('.', ',') : window.bb.fmt(v);
          if (p < 1) requestAnimationFrame(step); else span.textContent = m[1];
        }
        requestAnimationFrame(step);
      }
      if ('IntersectionObserver' in window) {
        var o = new IntersectionObserver(function(en) { if (en[0].isIntersecting) { run(); o.disconnect(); } }, { threshold: 0.4 });
        o.observe(el);
      } else run();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spotlight-model"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function pick(el, mp4Attr, hlsAttr) {
      var hls = el.getAttribute(hlsAttr);
      if (hls && el.canPlayType && el.canPlayType('application/vnd.apple.mpegurl')) return hls;
      return el.getAttribute(mp4Attr) || hls || '';
    }

    function init(root) {
      (root || document).querySelectorAll('[data-sm]').forEach(function (sec) {
        if (sec.__bb) return;
        sec.__bb = true;

        var spots = sec.querySelectorAll('[data-sm-spot]');
        var cards = sec.querySelectorAll('[data-sm-card]');
        var cur = 0, timer = null;
        var cycleMs = (parseInt(sec.getAttribute('data-cycle'), 10) || 0) * 1000;

        function show(i) {
          spots.forEach(function (s, k) { s.classList.toggle('is-on', k === i); s.setAttribute('aria-expanded', k === i ? 'true' : 'false'); });
          cards.forEach(function (c, k) { c.classList.toggle('is-on', k === i); });
          cur = i;
        }
        /* Tacke se same smenjuju dok korisnik ne dodirne neku, i samo dok je sekcija u ekranu */
        function stop() { if (timer) { clearInterval(timer); timer = null; } }
        function run() {
          if (reduce || cycleMs <= 0 || spots.length < 2 || timer) return;
          timer = setInterval(function () { show((cur + 1) % spots.length); }, cycleMs);
        }
        spots.forEach(function (s, i) {
          s.addEventListener('click', function () { show(i); stop(); sec.__touched = true; });
          s.addEventListener('mouseenter', function () { if (fine) { show(i); stop(); } });
        });
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (en) {
            en.forEach(function (e) { if (e.isIntersecting && !sec.__touched) run(); else stop(); });
          }, { threshold: 0.35 }).observe(sec);
        }

        /* Blago naginjanje slike za misem, samo na desktopu */
        var stage = sec.querySelector('[data-sm-stage]');
        var tilt = sec.querySelector('[data-sm-tilt]');
        if (stage && tilt && fine && !reduce) {
          var raf = null;
          stage.addEventListener('mousemove', function (e) {
            var r = stage.getBoundingClientRect();
            var x = (e.clientX - r.left) / r.width - 0.5;
            var y = (e.clientY - r.top) / r.height - 0.5;
            if (raf) return;
            raf = requestAnimationFrame(function () {
              raf = null;
              tilt.style.transform = 'rotateY(' + (x * 8) + 'deg) rotateX(' + (-y * 6) + 'deg)';
            });
          });
          stage.addEventListener('mouseleave', function () { tilt.style.transform = ''; });
        }

        /* Video preko celog ekrana sa zvukom, ucitava se tek na klik */
        var btn = sec.querySelector('[data-sm-video]');
        var box = document.querySelector('[data-sm-lightbox]');
        if (btn && box) {
          var lb = box.querySelector('[data-sm-lb-video]');
          function close() {
            box.classList.remove('is-open');
            lb.pause();
            document.body.style.overflow = '';
            setTimeout(function () { box.hidden = true; lb.removeAttribute('src'); lb.load(); }, 200);
          }
          btn.addEventListener('click', function () {
            lb.setAttribute('data-full', btn.getAttribute('data-full') || '');
            lb.setAttribute('data-full-hls', btn.getAttribute('data-full-hls') || '');
            lb.src = pick(lb, 'data-full', 'data-full-hls');
            box.hidden = false;
            requestAnimationFrame(function () { box.classList.add('is-open'); });
            document.body.style.overflow = 'hidden';
            var p = lb.play();
            if (p && p.catch) p.catch(function () {});
          });
          if (!box.__bb) {
            box.__bb = true;
            box.querySelector('[data-sm-close]').addEventListener('click', close);
            box.addEventListener('click', function (e) { if (e.target === box) close(); });
            document.addEventListener('keydown', function (e) { if (!box.hidden && e.key === 'Escape') close(); });
          }
        }
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test-ride"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.tr').forEach(function(sec) {
      var cards = sec.querySelectorAll('[data-tr-card]');
      var map = sec.querySelector('[data-tr-map]');
      if (!cards.length || !map) return;
      var key = (map.src.match(/key=([^&]+)/) || [])[1];
      if (!key) return;
      cards.forEach(function(card) {
        card.addEventListener('click', function(e) {
          if (e.target.closest('a')) return;
          cards.forEach(function(c) { c.classList.remove('tr__card--active'); });
          card.classList.add('tr__card--active');
          map.src = 'https://www.google.com/maps/embed/v1/place?key=' + key + '&q=' + card.getAttribute('data-map-query') + '&zoom=15';
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-testimonials]');
    if (!section) return;

    var track = section.querySelector('[data-testimonial-track]');
    var prevBtn = section.querySelector('[data-testimonial-prev]');
    var nextBtn = section.querySelector('[data-testimonial-next]');

    if (!track) return;

    function getScrollAmount() {
      var card = track.querySelector('.testimonials__card');
      if (!card) return 300;
      return card.offsetWidth + 16;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
